import { getVarConfig } from './environment';
import { cleanCookiesAndReload } from './cookiesUtils';

export default async function fetchAPI({
  params = {},
  service,
  protocol = 'POST',
  callbackThen,
  callbackError,
  customBody,
  customHeaders,
  noContentType,
  customParams,
  skipAuth = false,
}) {
  const urlService = getVarConfig({ key: 'REACT_APP_SERVICES_URL' }) + service;

  if (skipAuth) {
    fetch(urlService, {
      method: protocol,
      headers: {
        'Content-Type': 'application/json',
        ...customHeaders,
      },
      body: JSON.stringify(params),
    })
      .then(async (res) => {
        const text = await res.text();
        const jData = text ? JSON.parse(text) : {};

        if (res.ok) {
          if (typeof callbackThen !== 'undefined') {
            callbackThen(jData);
          }
        } else {
          if (typeof callbackError !== 'undefined') {
            callbackError(res.status, jData);
          }
        }
        return jData;
      })
      .catch((error) => {
        if (typeof callbackError !== 'undefined') {
          callbackError(error);
        }
      });
    return;
  }
  async function getBearerWithRetry(retries = 5, delay = 100) {
    let bearer = localStorage.getItem('bearer');
    let attempts = 0;
    while (!bearer && attempts < retries) {
      await new Promise((res) => setTimeout(res, delay));
      bearer = localStorage.getItem('bearer');
      attempts++;
    }
    return bearer;
  }

  const bearerNumber = await getBearerWithRetry();

  const options = {
    method: protocol,
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + bearerNumber,
      'CSRF-Token': window.CSRF_TOKEN,
    },
  };

  switch (protocol) {
    case 'POST':
      options.body = JSON.stringify(params);
      break;
    case 'PATCH':
      options.body = JSON.stringify(params);
      break;
    case 'PUT':
      options.body = JSON.stringify(params);
      break;
    case 'DELETE':
      options.body = JSON.stringify(params);
      break;
    default:
      if (protocol !== 'GET') console.log('Not recognized protocol: ' + protocol);
  }

  if (noContentType) {
    delete options.headers['Content-Type'];
  }

  options.body = customParams || customBody || options.body;
  options.headers = {
    ...options.headers,
    ...customHeaders,
  };

  return fetch(urlService, options)
    .then((response) => {
      return response.text().then((text) => {
        if (response.ok || response.status === 401) {
          return text;
        } else {
          if (typeof callbackError !== 'undefined') {
            // Se pasa el JSON ya parseado para evitar intentar releer el body consumido
            let parsedError = {};
            try { parsedError = text ? JSON.parse(text) : {}; } catch (_) {}
            callbackError(response.status, parsedError);
          } else {
            return 500;
          }
        }
      });
    })
    .then((data) => {
      // Si data es undefined significa que el error ya fue manejado por callbackError — no llamar callbackThen
      if (data === undefined) return;
      const jData = data ? JSON.parse(data) : {};
      if (jData.error === 'invalid_token') {
        localStorage.clear();
        cleanCookiesAndReload();
      }

      if (typeof callbackThen !== 'undefined') {
        callbackThen(jData);
      }
      return jData;
    })
    .catch((error) => {
      if (typeof callbackThen !== 'undefined') {
        callbackThen(error);
      }
    });
}
